import React from 'react'
import style from "../DashBoardLayout/styles/TopBar.module.css"
import Logoleft from "../../images/KFIN-logo.png"
import Logoright from "../../images/NPS-logo.png"
import Vector from "../../images/Vector.svg"
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import styles from "../DashBoardLayout/styles/SideBar.module.css"
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { FaRegCircleUser } from "react-icons/fa6";
import { TfiPieChart } from "react-icons/tfi";
import AssessmentIcon from '@mui/icons-material/Assessment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { IoLogOutOutline } from "react-icons/io5";
import { LuBuilding2 } from "react-icons/lu";
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { Collapse, Grid, colors } from "@mui/material";
import plus_img from "../../../src/images/plus.svg";
import minus_img from "../../../src/images/minus.svg";
import Hidden from '@mui/material/Hidden';


import { useState } from 'react'
import zIndex from '@mui/material/styles/zIndex'
const TopBar = ({setNavOpen}) => {
  const [showMenu,setShowMenu]=useState(false)
  const navigate=useNavigate();

  const [selectedIndex, setSelectedIndex] = useState(0);
  const[open,setOpen]= useState(false)
  const handleModuleState = (module) => {
    // console.log("ooooooo",module);
    setModuleStatus((prev) => {
      const newState = { ...prev };
      newState[module] = !newState[module];
      // console.log("newstarte", newState);
      return newState;
    });
  };
  const [moduleStatus, setModuleStatus] = useState({
    processingModule: false,
    reports: false,
    viewer: false,
  });
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };
    // const navigate = useNavigate()
  
      let reports=[
        {
          path: "/app/daily",
          img: <TodayIcon />,
          name: "Daily",
        },
        {
          path: "/app/weekly",
          img: <CalendarMonthIcon />,
          name: "Weekly",
        },
      ]
      
  return (
    // <div className={style.topbar}>
    //  
    // </div>
        <AppBar className={style.Appbar}>
        <Toolbar sx={{display:"flex", justifyContent:"space-between"}}>
          {/* <Typography variant="h6" component="div">
            Scroll to elevate App bar
          </Typography> */}
          {/* ddd */}
          <img src={Logoleft} alt="left-image" className={style.logoImg}></img>
          <img src={Logoright} alt="right-image" className={style.npsImg}></img>
          <Hidden mdUp>
          <img src={Vector} alt="right-image" className={style.VectorImg} onClick={setNavOpen}></img>
            </Hidden>      
        </Toolbar>
      </AppBar>
  )
}

export default TopBar